import { apiSahInvoiceAccountCodes } from '~constants/api';

import { get, post, remove } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'account-codes';

const config = [
  { actionType: 'getAll', apiPath: apiSahInvoiceAccountCodes, actionParams: { is_deleted: 'false' }, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiSahInvoiceAccountCodes}/${params.id}`, method: get },
  {
    actionType: 'deleteAccountCode',
    apiPath: (params: Params) => `${apiSahInvoiceAccountCodes}/${params.id}`,
    method: remove,
  },
  { actionType: 'upsert', apiPath: apiSahInvoiceAccountCodes, method: post },
];

export const { getAll, getOne, deleteAccountCode, upsert } = createThunks(typePrefix, config);
